import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

const locizeOptions = {
  projectId: process.env.REACT_APP_LOCIZE_PROJECTID,
  apiKey: process.env.REACT_APP_LOCIZE_APIKEY,
  refLang: process.env.REACT_APP_LOCIZE_REFLANG,
  version: process.env.REACT_APP_LOCIZE_VERSION,
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    returnEmptyString: false,
    interpolation: {
      format: function (value, format, lng) {
        //   if (value instanceof Date) return moment(value).format(format);
        if (typeof value === 'number') return new Intl.NumberFormat().format(value);
        return value;
      },
    },
    // backend: fsOptions,
    defaultNS: 'translation',
    // saveMissing: true,
  });

i18n.on('languageChanged', () => {
  // clear welcome message
  localStorage.removeItem('wf-msg');
});

// i18n.changeLanguage('en');

export { i18n };
